/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BookingDetails/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import DateTimeInProgress from './DateTimeInProgress/index'
import DateTimeMissed from './DateTimeMissed/index'
import DateTimeScheduled from './DateTimeScheduled/index'
import DateTimeUnScheduled from './DateTimeUnScheduled/index'
import PatientName from './PatientName/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function BookingDetails({
  children,
  viewPath = "/App/Account/Content/Content/Home/AppointmentBookings/Content/BookingDetails"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="BookingDetails.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1GeueS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<PatientName
  viewPath={`${viewPath}/PatientName`}
/>
<DateTimeMissed
  viewPath={`${viewPath}/DateTimeMissed`}
/>
<DateTimeScheduled
  viewPath={`${viewPath}/DateTimeScheduled`}
/>
<DateTimeInProgress
  viewPath={`${viewPath}/DateTimeInProgress`}
/>
<DateTimeUnScheduled
  viewPath={`${viewPath}/DateTimeUnScheduled`}
/>
</div>
{children}
</React.Fragment>)
}